module.exports={
  "default": [
    {
      "type": "image",
      "key": "help.arrow-up",
      "url": "assets/common/popups/help/arrow_up.png",
      "tags": "ui"
    },
    {
      "type": "image",
      "key": "help.arrow-down",
      "url": "assets/common/popups/help/arrow_down.png",
      "tags": "ui"
    },

    {
      "type": "image",
      "key": "help.paytable.diamond",
      "url": "assets/common/popups/help/paytable/diamond.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.glasses",
      "url": "assets/common/popups/help/paytable/glasses.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.guy",
      "url": "assets/common/popups/help/paytable/guy.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.microphone",
      "url": "assets/common/popups/help/paytable/microphone.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.old",
      "url": "assets/common/popups/help/paytable/old.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.raki",
      "url": "assets/common/popups/help/paytable/raki.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.ring",
      "url": "assets/common/popups/help/paytable/ring.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.singer",
      "url": "assets/common/popups/help/paytable/singer.png",
      "tags": "paytable"
    },
    {
      "type": "image",
      "key": "help.paytable.teshib",
      "url": "assets/common/popups/help/paytable/teshib.png",
      "tags": "paytable"
    },

    {
      "type": "image",
      "key": "help.paylines.1-2-3",
      "url": "assets/common/popups/help/paylines/1-2-3.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.4-5",
      "url": "assets/common/popups/help/paylines/4-5.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.6-7",
      "url": "assets/common/popups/help/paylines/6-7.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.8-9",
      "url": "assets/common/popups/help/paylines/8-9.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.10-11",
      "url": "assets/common/popups/help/paylines/10-11.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.12-13",
      "url": "assets/common/popups/help/paylines/12-13.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.14-15",
      "url": "assets/common/popups/help/paylines/14-15.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.16-17",
      "url": "assets/common/popups/help/paylines/16-17.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.18-19",
      "url": "assets/common/popups/help/paylines/18-19.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.20-21",
      "url": "assets/common/popups/help/paylines/20-21.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.22-23",
      "url": "assets/common/popups/help/paylines/22-23.png",
      "tags": "paylines"
    },
    {
      "type": "image",
      "key": "help.paylines.24-25",
      "url": "assets/common/popups/help/paylines/24-25.png",
      "tags": "paylines"
    },

    {
      "type": "image",
      "key": "help.wild-scatter.extra-symbols",
      "url": "assets/common/popups/help/wild-scatter/extra-symbols.png",
      "tags": "wild-scatter"
    },
    {
      "type": "image",
      "key": "help.wild-scatter.guy",
      "url": "assets/common/popups/help/wild-scatter/guy.png",
      "tags": "wild-scatter"
    },
    {
      "type": "image",
      "key": "help.wild-scatter.singer",
      "url": "assets/common/popups/help/wild-scatter/singer.png",
      "tags": "wild-scatter"
    },
    {
      "type": "image",
      "key": "help.wild-scatter.old",
      "url": "assets/common/popups/help/wild-scatter/old.png",
      "tags": "wild-scatter"
    },

    {
      "type": "image",
      "key": "help.bonus.bonus",
      "url": "assets/common/popups/help/bonus/bonus.png",
      "tags": "bonus"
    },
    {
      "type": "image",
      "key": "help.bonus.game-ui",
      "url": "assets/common/popups/help/bonus/game-ui.png",
      "tags": "bonus"
    }
  ]
}